import { OverviewData } from '@/interfaces'

export const overviews: OverviewData[] = [
  {
    date: '2025-01-01T00:00:00',
    'Rows written': 293,
    'Rows read': 31339,
    Queries: 485,
    'Payments completed': 1,
    'Sign ups': 72,
    Logins: 1982
  },
  {
    date: '2025-01-02T00:00:00',
    'Rows written': 2624,
    'Rows read': 27638,
    Queries: 484,
    'Payments completed': 1,
    'Sign ups': 74,
    Logins: 1883
  },
  {
    date: '2025-01-03T00:00:00',
    'Rows written': 2698,
    'Rows read': 29548,
    Queries: 480,
    'Payments completed': 1,
    'Sign ups': 70,
    Logins: 2022
  },
  {
    date: '2025-01-04T00:00:00',
    'Rows written': 2662,
    'Rows read': 29816,
    Queries: 484,
    'Payments completed': 1,
    'Sign ups': 78,
    Logins: 2057
  },
  {
    date: '2025-01-05T00:00:00',
    'Rows written': 2847,
    'Rows read': 31607,
    Queries: 481,
    'Payments completed': 1,
    'Sign ups': 76,
    Logins: 1883
  },
  {
    date: '2025-01-06T00:00:00',
    'Rows written': 2455,
    'Rows read': 31087,
    Queries: 481,
    'Payments completed': 1,
    'Sign ups': 73,
    Logins: 1869
  },
  {
    date: '2025-01-07T00:00:00',
    'Rows written': 2245,
    'Rows read': 30345,
    Queries: 482,
    'Payments completed': 1,
    'Sign ups': 75,
    Logins: 1941
  },
  {
    date: '2025-01-08T00:00:00',
    'Rows written': 801,
    'Rows read': 28435,
    Queries: 488,
    'Payments completed': 2,
    'Sign ups': 75,
    Logins: 2012
  },
  {
    date: '2025-01-09T00:00:00',
    'Rows written': 677,
    'Rows read': 30334,
    Queries: 489,
    'Payments completed': 1,
    'Sign ups': 77,
    Logins: 2082
  },
  {
    date: '2025-01-10T00:00:00',
    'Rows written': 1158,
    'Rows read': 31519,
    Queries: 486,
    'Payments completed': 2,
    'Sign ups': 76,
    Logins: 1910
  },
  {
    date: '2025-01-11T00:00:00',
    'Rows written': 2300,
    'Rows read': 31525,
    Queries: 484,
    'Payments completed': 2,
    'Sign ups': 76,
    Logins: 1812
  },
  {
    date: '2025-01-12T00:00:00',
    'Rows written': 2747,
    'Rows read': 29810,
    Queries: 489,
    'Payments completed': 2,
    'Sign ups': 71,
    Logins: 1970
  },
  {
    date: '2025-01-13T00:00:00',
    'Rows written': 460,
    'Rows read': 30737,
    Queries: 488,
    'Payments completed': 0,
    'Sign ups': 74,
    Logins: 1838
  },
  {
    date: '2025-01-14T00:00:00',
    'Rows written': 170,
    'Rows read': 31365,
    Queries: 483,
    'Payments completed': 1,
    'Sign ups': 79,
    Logins: 1852
  },
  {
    date: '2025-01-15T00:00:00',
    'Rows written': 2525,
    'Rows read': 29321,
    Queries: 483,
    'Payments completed': 1,
    'Sign ups': 78,
    Logins: 1848
  },
  {
    date: '2025-01-16T00:00:00',
    'Rows written': 1198,
    'Rows read': 29171,
    Queries: 484,
    'Payments completed': 1,
    'Sign ups': 72,
    Logins: 1813
  },
  {
    date: '2025-01-17T00:00:00',
    'Rows written': 117,
    'Rows read': 30591,
    Queries: 489,
    'Payments completed': 1,
    'Sign ups': 71,
    Logins: 1979
  },
  {
    date: '2025-01-18T00:00:00',
    'Rows written': 2053,
    'Rows read': 28685,
    Queries: 488,
    'Payments completed': 0,
    'Sign ups': 73,
    Logins: 1999
  },
  {
    date: '2025-01-19T00:00:00',
    'Rows written': 1567,
    'Rows read': 30450,
    Queries: 489,
    'Payments completed': 2,
    'Sign ups': 71,
    Logins: 1999
  }
]
